import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { Configuration, ModalManager } from '@pega/cosmos-react-core';
import { themeOverrides } from './redux/theme';
import getTranslations from './translations/allTranslations';

const Index = () => {
  const translations = getTranslations();
  return (
    <Provider store={store}>
      <Configuration theme={themeOverrides} translations={translations}>
        <ModalManager>
          <App />
        </ModalManager>
      </Configuration>
    </Provider>
  );
};
ReactDOM.render(<Index />, document.getElementById('root'));
